import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './CustomerPanel.scss';

function CustomerLayout() {
  return (
    <div className='admin-container'>
      <div className='sidebar'>
        <ul>
          <li><NavLink to="customerswitch" className={({ isActive }) => isActive ? 'active' : ''}>Customer Selection</NavLink></li>
        </ul>
      </div>
      <div className='main'>
        <Outlet />
      </div>
    </div>
  );
}

export default CustomerLayout;